export default __webpack_public_path__ + "static/envelope-build-action-1eb67ed3ec090726663e805086b31f16.png";